import url from 'url';

export default function ({ store, query, req, route }) {
  let referrer;
  let pathname;
  let userAgent = '';

  if (process.client) {
    userAgent = window.navigator.userAgent;
    referrer = store.state.dataLayer.visitable_path_manual;
    pathname = route.path;
  } else if (req) {
    userAgent = req.headers['user-agent'];
    if (req.headers.referer) {
      referrer = url.parse(req.headers.referer).pathname;
    }
    pathname = url.parse(req.url).pathname;
  }

  if((process.env.NUXT_ENV === 'prod' || process.env.NUXT_ENV === 'staging') && !query["healthcheck"]) {
    store.commit('DATA_LAYER_PUSH', {
      event: 'gambit.manual_do_enem.tracking',
      gclid: query["gclid"] || '',
      ip: '',
      lat: '',
      lng: '',
      partner_id: '',
      referrer: referrer,
      user_agent: userAgent,
      utm_campaign: query["utm_campaign"] || '',
      utm_content: query["utm_content"] || '',
      utm_medium: query["utm_medium"] || '',
      utm_source: query["utm_source"] || '',
      utm_term: query["utm_term"] || '',
      visitable_path_manual: `/enem${pathname}`,
      visitable_type: "manual_do_enem",
      zanpid: query["zanpid"] || '',
    });
  }

  if (process.client) {
    window.dataLayer.push(store.state.dataLayer);
  }
}
